module.exports = __webpack_public_path__ + "static/media/iiba-metroverse.04c1d089.png";